(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  /* Mega-panelen staan in een <template>: ingelezen maar niet opgebouwd.
     Bij de eerste blijk van interesse in de header vouwen we ze in een keer uit.
     Bewust GEEN uitgestelde her-opbouw op de achtergrond: dat zou alleen een
     meetscore flatteren en de winst op mobiel weer weggeven. */
  (() => {
    const header = document.querySelector('store-header') || document.querySelector('.cc-header');
    if (!header) return;
    let gedaan = false;
    const vouwUit = () => {
      if (gedaan) return;
      gedaan = true;
      header.querySelectorAll('template.js-mega-lazy').forEach((tpl) => {
        tpl.replaceWith(tpl.content.cloneNode(true));
      });
      /* js-sidebar-hover-herbinding: de panelen zaten in een <template>, dus MainMenu heeft
         bij zijn constructor NUL .js-sidebar-hover-links gezien en er geen hover-handler op
         gezet. Zonder dit opent het menu wel, maar toont hoveren over een collectie rechts
         geen producten (gemeten 19-08: 69 links, 0 gebonden). Alleen deze lijst opnieuw
         vastleggen en binden; init() bewust niet opnieuw aanroepen. */
      try {
        const mainMenu = header.querySelector('main-menu');
        const MainMenuCtor = customElements.get('main-menu');
        if (mainMenu && MainMenuCtor && typeof MainMenuCtor.handleSidenavMenuToggle === 'function') {
          mainMenu.sidebarLinks = mainMenu.querySelectorAll('.js-sidebar-hover');
          const magHoveren = window.theme && theme.device && theme.device.hasHover
            && theme.mediaMatches && theme.mediaMatches.md;
          if (magHoveren) {
            mainMenu.sidebarLinks.forEach((link) => {
              link.addEventListener('mouseenter', MainMenuCtor.handleSidenavMenuToggle);
            });
            mainMenu.mouseOverSidebarListening = true;
          }
        }
      } catch (e) { /* nooit de header slopen om een hover-verbetering */ }

      header.dispatchEvent(new CustomEvent('on:mega-nav:ready', { bubbles: true }));
    };
    const opties = { once: true, capture: true, passive: true };
    ['pointerenter', 'pointerdown', 'mouseover', 'mousedown', 'touchstart', 'click', 'focusin', 'keydown'].forEach((ev) => {
      header.addEventListener(ev, vouwUit, opties);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
